<app-admin-dashboard>
  <app-user-panel-detail/>
</app-admin-dashboard>